import { render, staticRenderFns } from "./IGroupsChart.vue?vue&type=template&id=3d618434&"
import script from "./IGroupsChart.vue?vue&type=script&lang=js&"
export * from "./IGroupsChart.vue?vue&type=script&lang=js&"
import style0 from "./IGroupsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip});
